import React from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';

const STATUSES = {
  LOCKED: 'Locked',
  OPENED: 'Opened',
  IN_PROGRESS: 'In Progress',
  WATCHED: 'Watched',
  MARKED_COMPLETE: 'Marked Complete',
};

const StudentVideoStatus = (props) => {
  const { videoStatus, responseStatus } = props;

  const getVideoStatus = (vidStatus, respStatus) => {
    if ([vidStatus, respStatus].includes(STATUSES.LOCKED)) {
      return { status: STATUSES.LOCKED };
    }

    if ([vidStatus, respStatus].includes(STATUSES.MARKED_COMPLETE)) {
      return { status: STATUSES.MARKED_COMPLETE };
    }

    const statusAndIcon = { status: videoStatus };

    if (vidStatus === STATUSES.OPENED) {
      const validResponseStatuses = [STATUSES.WATCHED, STATUSES.IN_PROGRESS];
      if (validResponseStatuses.includes(respStatus)) {
        statusAndIcon.status = respStatus;
      }
    }

    return statusAndIcon;
  };

  const { status: assignmentStatus } = getVideoStatus(
    videoStatus,
    responseStatus,
  );

  return <div className="assignment_status">{assignmentStatus}</div>;
};

StudentVideoStatus.displayName = 'StudentVideoStatus';

StudentVideoStatus.propTypes = {
  videoStatus: PropTypes.string,
  responseStatus: PropTypes.string,
};

StudentVideoStatus.defaultProps = {
  videoStatus: '',
  responseStatus: '',
};

export const UnconnectedStudentVideoStatus = StudentVideoStatus;

export default connectLean({
  mapState({ withWatchedVideo, isStarted }) {
    return {
      videoStatus: withWatchedVideo
        ? STATUSES.WATCHED
        : isStarted
          ? STATUSES.IN_PROGRESS
          : STATUSES.OPENED,
    };
  },
})(StudentVideoStatus);
